<template>
  <div class="ui-wrap">
    <div class="ui-box fill-box">
      <div class="row">
        <div class="lab require">{{ $t('form.Surname') }}:</div>
        <div class="content" :class="{ isError: empty.lastName }">
          <input
            type="text"
            v-model="info.lastName"
            @focus="resetErr('lastName')"
            @blur="isEmpty('lastName')"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.midName') }}:</div>
        <div class="content" :class="{ isError: empty.firstName }">
          <input
            type="text"
            v-model="info.firstName"
            @focus="resetErr('firstName')"
            @blur="isEmpty('firstName')"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.birth') }}:</div>
        <div class="content" :class="{ isError: empty.birthday }">
          <!-- 后端存储时候，为0，导致 -->
          <el-date-picker
            style="width: 100%"
            @click="resetErr('birthday')"
            class="ui-datepicker"
            type="date"
            v-model="info.birthday"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.gender') }}:</div>
        <div class="content">
          <label
            class="ui-radio"
            :class="{ checked: info.sex === 1 }"
            @click="info.sex = 1"
            >{{ $t('common.man') }}</label
          >
          <label
            class="ui-radio"
            :class="{ checked: info.sex === 2 }"
            @click="info.sex = 2"
            >{{ $t('common.female') }}</label
          >
          <!-- <label class="ui-radio" :class="{checked: info.sex === 0}" @click="info.sex = 0">{{$t("common.other")}}</label> -->
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.email') }}:</div>
        <div class="content" :class="{ isError: empty.linkEmail }">
          <input
            type="text"
            v-model="info.linkEmail"
            @focus="resetErr('linkEmail')"
            @blur="isEmpty('linkEmail')"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.telphone') }}:</div>
        <div class="content" :class="{ isError: empty.linkMobileNo }">
          <input
            type="text"
            v-model="info.linkMobileNo"
            @focus="resetErr('linkMobileNo')"
            @blur="isEmpty('linkMobileNo')"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.chinese') }}:</div>
        <div class="content">
          <label
            class="ui-radio"
            :class="{ checked: info.canSpeakChinese === 1 }"
            @click="info.canSpeakChinese = 1"
            >{{ $t('common.yes') }}</label
          >
          <label
            class="ui-radio"
            :class="{ checked: info.canSpeakChinese === 0 }"
            @click="info.canSpeakChinese = 0"
            >{{ $t('common.no') }}</label
          >
          <template v-if="info.canSpeakChinese === 1">
            <br />
            <label
              class="ui-checkbox"
              :class="{ checked: info.Mandarin }"
              @click="info.Mandarin = !info.Mandarin"
              >Mandarin</label
            >
            <label
              class="ui-checkbox"
              :class="{ checked: info.Cantonese }"
              @click="info.Cantonese = !info.Cantonese"
              >Cantonese</label
            >
          </template>
        </div>
      </div>
      <hr class="line" />
      <div class="row">
        <div class="lab require">
          {{ $t('form.univercity') }} / {{ $t('form.college') }}：
        </div>
        <div class="content university">
          <label
            class="ui-checkbox"
            :class="{ checked: Oxford.check }"
            @click="Oxford.check = !Oxford.check"
            >Oxford</label
          >
          <el-select
            class="ui-select"
            v-model="Oxford.select"
            :placeholder="$t('form.placeholder')"
            style="width: 200px"
          >
            <el-option
              v-for="(item, index) in Oxford.college"
              :key="index"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
          <label
            class="ui-checkbox"
            :class="{ checked: Cambridge.check }"
            @click="Cambridge.check = !Cambridge.check"
            >Cambridge</label
          >
          <el-select
            class="ui-select"
            v-model="Cambridge.select"
            :placeholder="$t('form.placeholder')"
            style="width: 200px"
          >
            <el-option
              v-for="(item, index) in Cambridge.college"
              :key="index"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="row">
        <div class="lab require">{{$t("form.education")}}</div>
        <div class="content university">
          <el-select class="ui-select" v-model="info.education" placeholder="请选择">
            <el-option v-for="item in educationArr" :value="item.id" :label="item.name" :key="item.id"></el-option>
          </el-select>
        </div>
      </div> -->
      <div class="row">
        <div class="lab require">{{ $t('form.present') }}：</div>
        <div class="content">
          <label
            class="ui-radio"
            :class="{ checked: capacity === 0 }"
            @click="capacity = 0"
            >Postgraduate</label
          >
          <label
            class="ui-radio"
            :class="{ checked: capacity === 1 }"
            @click="capacity = 1"
            >Graduate</label
          >
          <label
            class="ui-radio"
            :class="{ checked: capacity === 2 }"
            @click="capacity = 2"
            >Professional Tutor</label
          >
          <label
            class="ui-radio"
            style="margin-top: 15px"
            :class="{ checked: capacity === 3 }"
            @click="capacity = 3"
          >
            <input type="text" class="fill-input" v-model="capacityTxt" />
            <p class="tip">
              Please specify e.g. Professor, Director of Studies, Lecturer
            </p>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="lab">{{ $t('form.refer') }}：</div>
        <div class="content">
          <input type="text" class="fill-input" v-model="info.referredBy" />
          <p class="tip">
            Please provide email address; if not referred by anyone, please
            leave blank
          </p>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.course') }}：</div>
        <div class="content">
          <label
            v-for="(item, index) in courseList"
            :key="item.courseId"
            class="ui-checkbox"
            :class="{ checked: item.state }"
            @click="setCourseState(index)"
            >{{ item.courseName }}</label
          >
        </div>
      </div>
      <div class="line"></div>
      <div class="row" v-if="showTauthIndex !== 4">
        <div class="lab require">{{ $t('form.taught') }}：</div>
        <div class="content">
          <table
            v-for="(item, index) in subjectList"
            :key="item.courseId"
            v-show="showTauthIndex === index"
            style="white-space: nowrap"
          >
            <div v-if="index !== 2">
              <tr v-for="cell in item.arr" :key="cell.subjectId">
                <td @click="empty.taughtSubjects = false">
                  <label
                    class="ui-checkbox"
                    :class="{ checked: cell.checked }"
                    @click="cell.checked = !cell.checked"
                    >{{ cell.subjectName }}</label
                  ><input
                    v-if="cell.isNeedMark"
                    type="text"
                    :placeholder="cell.markHoldPlace"
                    v-model="cell.mark"
                    class="subMore"
                  />
                </td>
                <td v-if="cell.show">
                  <label
                    class="ui-radio"
                    :class="{ checked: cell.subjectLevel === 2 }"
                    @click="cell.subjectLevel = 2"
                    >SL</label
                  >
                </td>
                <td v-if="cell.show">
                  <label
                    class="ui-radio"
                    :class="{ checked: cell.subjectLevel === 1 }"
                    @click="cell.subjectLevel = 1"
                    >HL</label
                  >
                </td>
              </tr>
            </div>
            <div v-else>
              <tr v-for="cell in item.arr" :key="cell.subjectId">
                <td @click="empty.taughtSubjects = false">
                  <label
                    class="ui-checkbox"
                    :class="{ checked: cell.checked }"
                    @click="cell.checked = !cell.checked"
                    >{{ cell.subjectName }}</label
                  ><input
                    v-if="cell.isNeedMark"
                    type="text"
                    :placeholder="cell.markHoldPlace"
                    v-model="cell.mark"
                    class="subMore"
                  />
                </td>
                <td v-if="cell.show">
                  <label
                    class="ui-radio"
                    :class="{ checked: cell.subjectLevel === 2 }"
                    @click="cell.subjectLevel = 2"
                    >SL</label
                  >
                </td>
                <td v-if="cell.show">
                  <label
                    class="ui-radio"
                    :class="{ checked: cell.subjectLevel === 1 }"
                    @click="cell.subjectLevel = 1"
                    >HL</label
                  >
                </td>
              </tr>
            </div>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="lab" style="top: 20px">{{ $t('form.other') }}</div>
        <div class="content">
          <ul class="subList">
            <li v-for="(item, index) in others" :key="index">
              <span class="num">{{ index + 1 }}、</span
              ><input type="text" class="fill-input" v-model="others[index]" />
            </li>
          </ul>
        </div>
      </div>
      <div class="line"></div>
      <div class="row">
        <div class="lab">{{ $t('form.identity') }} ：</div>
        <div class="content">
          <div class="img-list">
            <el-upload
              :headers="myHeaders"
              :action="uploadUrl"
              :on-success="uploadIdentity"
              :data="uploadData"
              name="uploadFile"
              :with-credentials="true"
              list-type="picture-card"
              :file-list="Identity"
              :on-remove="handleRemove"
            >
              <i class="img-add"></i>
            </el-upload>
          </div>
          <p class="tip2">Proof of Identity (passport page)</p>
          <div class="img-list">
            <el-upload
              :headers="myHeaders"
              :action="uploadUrl"
              :on-success="uploadIdentity2"
              :data="uploadData"
              name="uploadFile"
              :with-credentials="true"
              list-type="picture-card"
              :file-list="Identity2"
              :on-remove="handleRemove2"
            >
              <i class="img-add"></i>
            </el-upload>
          </div>
          <!-- <p class="tip2">Fully up-to-date Disclosure and Barring Service Certificate (or equivalent)</p>
          <div class="img-list">
            <el-upload :headers="myHeaders" :action="uploadUrl" :on-success="uploadIdentity3" :data="uploadData" name="uploadFile" :with-credentials="true" list-type="picture-card" :file-list="Identity3" :on-remove="handleRemove3">
              <i class="img-add"></i>
            </el-upload>
          </div> -->
          <p class="tip2">Graduate Certificate (or equivalent)</p>
          <div class="img-list">
            <el-upload
              :headers="myHeaders"
              :action="uploadUrl"
              :on-success="uploadIdentity4"
              :data="uploadData"
              name="uploadFile"
              :with-credentials="true"
              list-type="picture-card"
              :file-list="Identity4"
              :on-remove="handleRemove4"
            >
              <i class="img-add"></i>
            </el-upload>
          </div>
          <p class="tip2">C.V.</p>
        </div>
      </div>
      <div class="line"></div>
      <div class="row">
        <div class="lab require">{{ $t('form.teachexperience') }} :</div>
        <div class="content">
          <label
            class="ui-radio"
            :class="{ checked: onlineExperience }"
            @click="onlineExperience = true"
            >{{ $t('common.yes') }}</label
          >
          <label
            class="ui-radio"
            :class="{ checked: !onlineExperience }"
            @click="onlineExperience = false"
            >{{ $t('common.no') }}</label
          >
          <el-select
            v-model="onlineYears"
            style="width: 130px"
            class="ui-select"
            v-show="onlineExperience"
          >
            <el-option v-for="n in 20" :key="n" :value="n">{{ n }}</el-option>
          </el-select>
          <span class="unit" v-show="onlineExperience">{{ $t('year') }}</span>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.anyonlineexperience') }} :</div>
        <div class="content">
          <label
            class="ui-radio"
            :class="{ checked: onlineTeachingExperience }"
            @click="onlineTeachingExperience = true"
            >{{ $t('common.yes') }}</label
          >
          <label
            class="ui-radio"
            :class="{ checked: !onlineTeachingExperience }"
            @click="onlineTeachingExperience = false"
            >{{ $t('common.no') }}</label
          >
          <el-select
            v-model="onlineTeachingYears"
            style="width: 130px"
            class="ui-select"
            v-show="onlineTeachingExperience"
          >
            <el-option v-for="n in 20" :key="n" :value="n">{{ n }}</el-option>
          </el-select>
          <span class="unit" v-show="onlineTeachingExperience">{{
            $t('year')
          }}</span>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.teachWeek') }}:</div>
        <div class="content">
          <el-select
            v-model="info.tutorialHoursPerWeek"
            style="width: 130px"
            class="ui-select"
          >
            <el-option v-for="n in 50" :key="n" :value="n">{{ n }}</el-option>
          </el-select>
          <span class="unit">{{ $t('hours') }}</span>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.tutorTime') }}:</div>
        <div class="content">
          <div class="input-select">
            <input type="text" class="fill-input" v-model="long.num" />
            <div class="select-item">
              <el-select
                class="ui-select"
                v-model="long.select"
                style="width: 140px"
              >
                <el-option
                  :key="index"
                  v-for="(item, index) in long.unit"
                  :value="item"
                  >{{ item }}</el-option
                >
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.zone') }}：</div>
        <div class="content">
          <div class="timezone" v-if="timeZoneArr.length" ref="timezone">
            <a class="zonevalue" @click="showZone = !showZone"
              >({{ timeZoneArr[zoneIndex].timeZone }})
              {{ timeZoneArr[zoneIndex].timeZoneEnName }}</a
            >
            <ul class="zone-list" v-show="showZone">
              <li
                v-for="(item, index) in timeZoneArr"
                :key="item.id"
                :class="{ on: index === zoneIndex }"
                @click="setZone(index)"
              >
                ({{ item.timeZone }}) {{ item.timeZoneEnName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <p class="area-lab require">{{ $t('form.achievements') }}：</p>
      <div :class="{ isError: empty.achievements }">
        <textarea
          class="fill-area"
          @focus="resetErr('achievements')"
          @blur="isEmpty('achievements')"
          v-model="info.achievements"
          placeholder="Not more than 500 words"
        ></textarea>
      </div>
      <div class="row">
        <div class="lab require">{{ $t('form.avatar') }}：</div>
        <div class="content" :class="{ isError: empty.userPhotoUrl }">
          <div class="img-list">
            <el-upload
              :headers="myHeaders"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="uploadAvatar"
              :data="uploadData"
              name="uploadFile"
              :with-credentials="true"
            >
              <img
                v-if="info.userPhotoUrl"
                :src="info.userPhotoUrl"
                style="object-fit: cover"
                class="avatar"
              />
              <i class="img-add" v-else></i>
            </el-upload>
          </div>
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <p class="area-lab require">{{ $t('form.yourself') }}：</p>
      <div :class="{ isError: empty.introduction }">
        <textarea
          class="fill-area"
          @focus="resetErr('introduction')"
          @blur="isEmpty('introduction')"
          v-model="info.introduction"
          placeholder="Not more than 500 words"
        ></textarea>
      </div>
      <div class="row">
        <div class="lab">{{ $t('form.video') }}：</div>
        <div class="content">
          <div class="img-list video">
            <el-upload
              :headers="myHeaders"
              :action="mediaUrl"
              :show-file-list="false"
              :before-upload="beforeupload"
              :on-success="uploadMediaSuccess"
              :data="uploadData"
              name="upload"
            >
              <span class="tip" v-if="info.introductoryVideoUrl === 'upload'"
                >上传中</span
              >
              <video
                :src="info.introductoryVideoUrl"
                v-else-if="info.introductoryVideoUrl"
              ></video>
              <i class="img-add" v-else></i>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="row">
        <div class="lab" :class="{ require: type }">
          Bank Country or Region：
        </div>
        <div class="content" :class="{ isError: empty.bankCountry }">
          <input
            type="text"
            v-model="info.bankCountry"
            @focus="resetErr('bankCountry')"
            @blur="isEmpty('bankCountry')"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab" :class="{ require: type }">Account Name：</div>
        <div class="content" :class="{ isError: empty.bankAccountName }">
          <input
            type="text"
            @focus="resetErr('bankAccountName')"
            @blur="isEmpty('bankAccountName')"
            v-model="info.bankAccountName"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab" :class="{ require: type }">Bank Name：</div>
        <div class="content" :class="{ isError: empty.bankName }">
          <input
            type="text"
            @focus="resetErr('bankName')"
            @blur="isEmpty('bankName')"
            v-model="info.bankName"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab" :class="{ require: type }">
          IBAN / Account Number：
        </div>
        <div class="content" :class="{ isError: empty.bankAccountNO }">
          <input
            type="text"
            @focus="resetErr('bankAccountNO')"
            @blur="isEmpty('bankAccountNO')"
            v-model="info.bankAccountNO"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="lab" :class="{ require: type }">
          Bank Number / Sort Code：
        </div>
        <div class="content" :class="{ isError: empty.bankSortCode }">
          <input
            v-model="info.bankSortCode"
            @focus="resetErr('bankSortCode')"
            @blur="isEmpty('bankSortCode')"
            type="text"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="row">
        <div
          class="lab"
          :class="{ require: type }"
          style="left: -30px; width: 370px"
        >
          Personal Address (as registered with bank account)：
        </div>
        <div class="content" :class="{ isError: empty.address }">
          <input
            v-model="info.address"
            @focus="resetErr('address')"
            @blur="isEmpty('address')"
            type="text"
            class="fill-input"
          />
          <p class="error">{{ $t('common.formTip') }}</p>
        </div>
      </div>
      <div class="bottom">
        <a class="btn-submit" @click="submit">{{ $t('common.submit') }}</a>
      </div>
    </div>
    <div class="ui-pop" v-if="isShow">
      <div class="ui-mask"></div>
      <div class="ui-comfirm ui-modal" style="min-height: 340px">
        <p class="title">提示</p>
        <div class="content">
          <p class="topic">您的资料已提交到后台，请耐心等待审核</p>
          <p class="desc">审核通过前，您只能进行浏览，无法进行课程排期。</p>
          <div class="btns">
            <a class="ui-btn" @click="gohome">知道了</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Select from '@/components/Select.vue'
import baseUrl from '@/service/env.js'
import {
  perfectMyProfile,
  getProfile,
  getMyBankList,
  createBank,
  modifyBank,
  getSchoolList,
  getCollegeList,
} from '@/service/teacherApi.js'
import {
  updateUserPhoto,
  getCourseList,
  getSubjectList,
  getTimeZoneList,
  getCountryList,
} from '@/service/api.js'
import moment from 'moment'
import jstz from 'jstz'
export default {
  components: { Select },
  data() {
    return {
      info: {
        lastName: '',
        firstName: '',
        birthday: '',
        sex: 1,
        mobileNO: '',
        email: '',
        canSpeakChinese: 1,
        Mandarin: false,
        Cantonese: false,
        languageList: '',
        presentCapacity: '',
        referredBy: '',
        // education: 2,
        course: 1,
        identityProof: '',
        taughtSubjects: [],
        tutorialHoursPerWeek: 1,
        anticipateTutoringDuration: '',
        introductoryVideoUrl: '',
        userPhotoUrl: '',
        achievements: '',
        introduction: '',
        bankCountry: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNO: '',
        bankSortCode: '',
        address: '',
        isDefault: 1,
      },
      Oxford: {
        check: false,
        college: [
          'All Souls College',
          'Balliol College',
          'Blackfriars',
          'Brasenose College',
          'Campion Hall',
          'Christ Church',
          'Corpus Christi College',
          'Exeter College',
          'Green Templeton College',
          'Harris Manchester College',
          'Hertford College',
          'Jesus College',
          'Keble College',
          'Kellogg College',
          'Lady Margaret Hall',
          'Linacre College',
          'Lincoln College',
          'Magdalen College',
          'Mansfield College',
          'Merton College',
          'New College',
          'Nuffield College',
          'Oriel College',
          'Parks College',
          'Pembroke College',
          "The Queen's College",
          "Regent's Park College",
          "St Anne's College",
          "St Antony's College",
          "St Benet's Hall",
          "St Catherine's College",
          'St Cross College',
          'St Edmund Hall',
          "St Hilda's College",
          "St Hugh's College",
          "St John's College",
          "St Peter's College",
          "St Stephen's House",
          'Somerville College',
          'Trinity College',
          'University College',
          'Wadham College',
          'Wolfson College',
          'Worcester College',
          'Wycliffe Hall',
        ],
        select: '',
      },
      Cambridge: {
        check: false,
        college: [
          "Christ's College",
          'Churchill College',
          'Clare College',
          'Clare Hall',
          'Corpus Christi College',
          'Darwin College',
          'Downing College',
          'Emmanuel College',
          'Fitzwilliam College',
          'Girton College',
          'Gonville and Caius College',
          'Homerton College',
          'Hughes Hall',
          'Jesus College',
          "King's College",
          'Lucy Cavendish College',
          'Magdalene College',
          'Murray Edwards College',
          'Newnham College',
          'Pembroke College',
          'Peterhouse',
          "Queens' College",
          'Robinson College',
          'Selwyn College',
          'Sidney Sussex College',
          "St Catharine's College",
          "St Edmund's College",
          "St John's College",
          'Trinity College',
          'Trinity Hall',
          'Wolfson College',
        ],
        select: '',
      },
      capacity: 0,
      capacityTxt: '',
      others: ['', '', '', '', ''],
      onlineExperience: true,
      onlineTeachingExperience: true,
      onlineTeachingYears: 1,
      onlineYears: 1,
      courseList: [],
      subjectList: [],
      showTauthIndex: 4,
      // educationArr: [{id: 1, name: '高中'}, {id: 2, name: '学士'}, {id: 3, name: '硕士'}, {id: 4, name: '博士'}, {id: 5, name: '博士后'}, {id: 6, name: '博导'}],
      long: {
        num: '',
        unit: ['years', 'months'],
        select: 'years',
      },
      empty: {
        // 不为空的字段
        lastName: 0,
        firstName: 0,
        birthday: 0,
        linkMobileNo: 0,
        linkEmail: 0,
        achievements: 0,
        introduction: 0,
        userPhotoUrl: 0,
        taughtSubjects: 0,
        bankCountry: undefined, // undefined为非必填
        bankName: undefined,
        bankAccountName: undefined,
        bankAccountNO: undefined,
        bankSortCode: undefined,
        address: undefined,
      },
      Identity: [],
      Identity2: [],
      Identity3: [],
      Identity4: [],
      shortVideo: [],
      uploadData: { fn: 'edu', dw: 192, dh: 192 },
      haveBankInfo: false,
      uploadUrl: baseUrl + '/upload/uploadPic',
      mediaUrl: baseUrl + '/upload/uploadMedia',
      isShow: false, // 第一次填空资料提示审核状态
      type: 0, //type == 0时，为创建时提交资料，type == 1时，为个人中心修改资料
      timeZoneArr: [],
      zoneIndex: 0,
      showZone: false,
    }
  },
  methods: {
    resetErr(obj) {
      // 点击输入框时，去除错误状态
      if (this.empty[obj] !== undefined) {
        this.empty[obj] = 0
      }
    },
    isEmpty(obj) {
      // 判断字段是否为空
      if (this.empty[obj] !== undefined) {
        if (this.info[obj].length === 0) {
          this.empty[obj] = 1
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    setCourseState(i) {
      this.courseList[i].state = !this.courseList[i].state
      if (this.courseList[0].state && this.courseList[1].state) {
        this.showTauthIndex = 2
        // console.log(this.subjectList)
      } else if (!this.courseList[0].state && !this.courseList[1].state) {
        this.showTauthIndex = 4
      } else if (this.courseList[0].state) {
        this.showTauthIndex = 0
      } else {
        this.showTauthIndex = 1
      }
    },
    async initSubject() {
      // 获取课程与科目列表
      let res = await getCourseList()
      if (res.data.status === 1) {
        let arr = []
        this.courseList = res.data.data
        for (let i = 0; i < this.courseList.length; i++) {
          let obj = { state: false }
          obj.courseId = this.courseList[i].courseId
          res = await getSubjectList({ courseId: obj.courseId })
          if (res.data.status === 1) {
            obj.arr = res.data.data
            for (let j = 0; j < obj.arr.length; j++) {
              // console.log(obj.arr[j]);
              obj.arr[j].subjectLevel = ''
              obj.arr[j].mark = ''
              obj.arr[j].checked = false
              if (obj.courseId === 2) {
                if (obj.arr[j].isNeedLevel === 1) {
                  obj.arr[j].show = true
                }
              }
            }
            obj.arr.sort((a1, b1) => {
              let a = a1.subjectName.toLowerCase()
              let b = b1.subjectName.toLowerCase()
              if (a < b) return -1
              if (a > b) return 1
              return 0
            })
            this.subjectList.push(obj)
            if (this.subjectList.length === this.courseList.length) {
              if (this.$route.query.type == 1) {
                this.type = 1
                this.getProfile()
                this.getMyBankList()
              }
            }
            arr = arr.concat(obj.arr)
            // console.log(arr);
          }
        }
        const val = new Map()
        arr = arr.filter(
          (arr) => !val.has(arr.subjectName) && val.set(arr.subjectName, 1)
        )
        this.subjectList.push({ arr: arr })
        // console.log(this.subjectList);
      }
    },
    getCheckSubject() {
      // 整合选中的课程及科目
      let subject = []
      switch (this.showTauthIndex) {
        case 0:
          this.info.course = '1'
          break
        case 1:
          this.info.course = '2'
          break
        case 2:
          this.info.course = '1,2'
          break
        case 4:
          return false
      }
      let obj = this.subjectList[this.showTauthIndex].arr
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].checked) {
          subject.push(obj[i])
          // level.push(obj[i].level)
        }
      }
      // console.log(subject)
      this.info.taughtSubjects = JSON.stringify(subject)
    },
    submit() {
      this.getUpdateInfo()
      this.getCheckSubject()
      if (
        this.info.bankCountry ||
        this.info.bankName ||
        this.info.bankAccountName ||
        this.info.bankAccountNO ||
        this.info.bankSortCode ||
        (this.info.address && this.type !== 1)
      ) {
        this.setBankRequst(0)
      } else if (
        !this.info.bankCountry &&
        !this.info.bankName &&
        !this.info.bankAccountName &&
        !this.info.bankAccountNO &&
        !this.info.bankSortCode &&
        !this.info.address &&
        this.type !== 1
      ) {
        this.setBankRequst(undefined)
      }
      let state = true
      if (this.showTauthIndex === 4) {
        state = false
      }
      let state2 = ''
      for (let item in this.empty) {
        state2 = this.isEmpty(item)
        // console.log(item, state2)
        if (state2) {
          state = false
        }
      }
      if (state) {
        let info = JSON.parse(JSON.stringify(this.info));
        info.birthday = moment(info.birthday, 'YYYY-MM-DD').format(
          'YYYYMMDD'
        );
        let submit1, submit2, submit3
        submit1 = new Promise((resolve, reject) => {
          perfectMyProfile(info)
            .then((res) => {
              resolve(res.data)
            })
            .catch((err) => {
              reject(err)
            })
        })
        submit2 = new Promise((resolve, reject) => {
          updateUserPhoto({ userPhoto: this.info.userPhotoUrl })
            .then((res) => {
              resolve(res.data)
            })
            .catch((err) => {
              reject(err)
            })
        })
        if (this.empty.bankCountry !== undefined) {
          if (this.haveBankInfo) {
            submit3 = new Promise((resolve, reject) => {
              modifyBank(this.info)
                .then((res) => {
                  resolve(res.data)
                })
                .catch((err) => {
                  reject(err)
                })
            })
          } else {
            submit3 = new Promise((resolve, reject) => {
              createBank(this.info)
                .then((res) => {
                  resolve(res.data)
                })
                .catch((err) => {
                  reject(err)
                })
            })
          }
        }
        Promise.all([submit1, submit2, submit3]).then((res) => {
          if (
            res[0].status === 1 &&
            res[1].status === 1 &&
            (res[2] === undefined || res[2].status === 1)
          ) {
            if (this.type === 1) {
              this.$message({ type: 'success', message: this.$t('common.updateSuccess') })
              this.$router.push({ path: '/user/info2' })
              let user = {
                loginState: true,
                userType: 20,
                uid: this.user.uid,
                userName: this.info.firstName + this.info.lastName,
                userPhoto: this.info.userPhotoUrl,
              }
              this.$store.dispatch('SETUSER', user)
            } else {
              this.isShow = true
              let user = {
                loginState: true,
                userType: 20,
                uid: this.user.uid,
                userName: this.info.firstName + this.info.lastName,
                userPhoto: this.info.userPhotoUrl,
              }
              this.$store.dispatch('SETUSER', user)
            }
          }
        })
      }
    },
    uploadMediaSuccess(res, file) {
      this.info.introductoryVideoUrl = res.url
    },
    beforeupload() {
      this.info.introductoryVideoUrl = 'upload'
    },
    uploadAvatar(res, file) {
      this.$set(this.info, 'userPhotoUrl', res.origUrl)
    },
    uploadIdentity(res, file) {
      this.Identity.push({ name: '', url: res.origUrl })
    },
    uploadIdentity2(res, file) {
      this.Identity2.push({ name: '', url: res.origUrl })
    },
    uploadIdentity3(res, file) {
      this.Identity3.push({ name: '', url: res.origUrl })
    },
    uploadIdentity4(res, file) {
      this.Identity4.push({ name: '', url: res.origUrl })
    },
    handleRemove(file, fileList) {
      let i = this.Identity.indexOf({ name: '', url: file.url })
      this.Identity.splice(i, 1)
    },
    handleRemove2(file, fileList) {
      let i = this.Identity2.indexOf({ name: '', url: file.url })
      this.Identity2.splice(i, 1)
    },
    handleRemove3(file, fileList) {
      let i = this.Identity3.indexOf({ name: '', url: file.url })
      this.Identity3.splice(i, 1)
    },
    handleRemove4(file, fileList) {
      let i = this.Identity4.indexOf({ name: '', url: file.url })
      this.Identity4.splice(i, 1)
    },
    getUpdateInfo() {
      // 生日
      // this.info.birthday = moment(this.info.birthday).format('YYYYMMDD')
      // 整合上传信息
      let arr = [],
        arr2 = []
      // 整合语言信息
      if (this.info.Mandarin) {
        arr.push('Mandarin')
      }
      if (this.info.Cantonese) {
        arr.push('Cantonese')
      }
      this.info.languageList = arr.join()
      // 整合学院专业
      arr = []
      if (this.Oxford.check) {
        arr.push('Oxford')
        arr2.push(this.Oxford.select)
      }
      if (this.Cambridge.check) {
        arr.push('Cambridge')
        arr2.push(this.Cambridge.select)
      }
      this.info.universitys = arr.join(',')
      this.info.colleges = arr2.join(',')
      // 整合当前岗位
      switch (this.capacity) {
        case 0:
          this.info.presentCapacity = 'Postgraduate'
          break
        case 1:
          this.info.presentCapacity = 'Graduate'
          break
        case 2:
          this.info.presentCapacity = 'Professional Tutor'
          break
        case 3:
          this.info.presentCapacity = this.capacityTxt
          break
      }
      // 整合图片信息
      arr = []
      arr2 = ['Identity', 'Identity2', 'Identity3', 'Identity4']
      for (let i = 0; i < 4; i++) {
        if (this[arr2[i]].length !== 0) {
          for (let j = 0; j < this[arr2[i]].length; j++) {
            arr.push(this[arr2[i]][j].url + '?t=' + (i + 1))
          }
        }
      }
      this.info.identityProof = arr.join('$_$')
      this.info.anyOtherSubjects = this.others.join()
      // 整合教龄
      if (!this.onlineExperience) {
        this.info.teachingExperience = 0
      } else {
        this.info.teachingExperience = this.onlineYears
      }
      // 网上教龄
      if (!this.onlineTeachingExperience) {
        this.info.onlineTeachingExperience = 0
      } else {
        this.info.onlineTeachingExperience = this.onlineTeachingYears
      }
      // 期望补课时长
      if (this.long.select === 'years') {
        this.info.anticipateTutoringDuration = this.long.num * 12
      } else {
        this.info.anticipateTutoringDuration = this.long.num
      }
      this.info.timeZone = this.timeZoneArr[this.zoneIndex].timeZone
    },
    uploadSuccess(res, file, fileList) {
      this.Identity.push({ name: '', url: res.url })
    },
    async getProfile() {
      let res = await getProfile()
      if (res.data.status === 1) {
        let data = res.data
        for (let val in data) {
          // 不直接相等，避免头像银行卡字段被删掉
          if (val === 'birthday') {
            if (val !== 0) {
              this.info[val] = moment(res.data[val], 'YYYYMMDD').format(
                'YYYY-MM-DD'
              )
            }
          } else if (!res.data.mobileNO && val === 'mobileNo') {
            this.info.mobileNO = res.data.mobileNo
          } else {
            this.info[val] = res.data[val]
          }
        }
        if (data.languageList.indexOf('Mandarin') !== -1) {
          this.info.Mandarin = true
        }
        if (data.languageList.indexOf('Cantonese') !== -1) {
          this.info.Cantonese = true
        }
        let arr = [],
          arr2 = [],
          arr3 = []
        arr = data.universitys.split(',')
        arr2 = data.colleges.split(',')
        if (arr.indexOf('Oxford') !== -1) {
          this.Oxford.check = true
          this.Oxford.select = arr2[arr.indexOf('Oxford')]
        }
        if (arr.indexOf('Cambridge') !== -1) {
          this.Cambridge.check = true
          this.Cambridge.select = arr2[arr.indexOf('Cambridge')]
        }
        switch (data.presentCapacity) {
          case 'Postgraduate':
            this.capacity = 0
            break
          case 'Graduate':
            this.capacity = 1
            break
          case 'Professional Tutor':
            this.capacity = 2
            break
          default:
            this.capacity = 3
            this.capacityTxt = data.presentCapacity
            break
        }
        arr = data.course.split(',')
        if (arr.indexOf('1') !== -1) {
          this.setCourseState(0)
        }
        if (arr.indexOf('2') !== -1) {
          this.setCourseState(1)
        }
        if (data.anyOtherSubjects) {
          this.others = data.anyOtherSubjects.split(',')
        }
        if (data.anticipateTutoringDuration % 12 === 0) {
          this.long.select = 'years'
          this.long.num = data.anticipateTutoringDuration / 12
        } else {
          this.long.select = 'months'
          this.long.num = data.anticipateTutoringDuration
        }
        if (data.teachingExperience) {
          this.onlineExperience = true
          this.onlineYears = data.teachingExperience
        } else {
          this.onlineExperience = false
        }
        // 网上教龄
        if (data.onlineTeachingExperience) {
          this.onlineTeachingExperience = true
          this.onlineTeachingYears = data.onlineTeachingExperience
        } else {
          this.onlineTeachingExperience = false
        }
        let id = 0
        for (let j = 0; j < this.subjectList.length; j++) {
          if (this.subjectList[j].courseId == res.data.course) {
            id = j
          } else {
            id = this.subjectList.length - 1
          }
        }
        for (let i = 0; i < res.data.taughtSubjects.length; i++) {
          for (let n = 0; n < this.subjectList[id].arr.length; n++) {
            if (
              this.subjectList[id].arr[n].subjectId ===
              res.data.taughtSubjects[i].subjectId
            ) {
              this.subjectList[id].arr[n].checked = true
              this.subjectList[id].arr[n].mark = res.data.taughtSubjects[i].mark
              this.subjectList[id].arr[n].subjectLevel =
                res.data.taughtSubjects[i].subjectLevel
            } else {
              for (let n = 0; n < this.subjectList[id].arr.length; n++) {
                if (
                  this.subjectList[id].arr[n].subjectId ===
                  res.data.taughtSubjects[i].subjectId
                ) {
                  this.subjectList[id].arr[n].checked = true
                  this.subjectList[id].arr[n].mark =
                    res.data.taughtSubjects[i].mark
                  this.subjectList[id].arr[n].subjectLevel =
                    res.data.taughtSubjects[i].subjectLevel
                }
              }
            }
          }
        }
        // console.log(this.subjectList);
        for (let i = 0; i < res.data.identityProof.length; i++) {
          let val = res.data.identityProof[i].split('?t=')
          if (val[1] == 1) {
            this.Identity.push({ name: '', url: val[0] })
          } else {
            this['Identity' + val[1]].push({ name: '', url: val[0] })
          }
        }
        for (let i = 0; i < this.timeZoneArr.length; i++) {
          if (res.data.timeZone === this.timeZoneArr[i].timeZone) {
            this.zoneIndex = i
          }
        }
      }
    },
    async getMyBankList() {
      let res = await getMyBankList()
      if (res.data.status === 1) {
        if (res.data.data.length !== 0) {
          let obj = res.data.data[0]
          for (let val in obj) {
            this.info[val] = obj[val]
          }
          if (obj.bankAccountNO === undefined) {
            this.info.bankAccountNO = obj.bankAccountNo
          }
          this.haveBankInfo = true
        }
      }
    },
    setBankRequst(val) {
      this.empty.bankCountry = val
      this.empty.bankName = val
      this.empty.bankAccountName = val
      this.empty.bankAccountNO = val
      this.empty.bankSortCode = val
      this.empty.address = val
    },
    async getTimeZoneList() {
      let res = await getTimeZoneList()
      if (res.data.status === 1) {
        this.timeZoneArr = res.data.data
      }
    },
    async getCountryList() {
      const res = await getCountryList()
    },
    gohome() {
      this.$router.push({ path: '/home' })
    },
    setZone(i) {
      this.zoneIndex = i
      this.showZone = false
    },
    async getSchoolList() {
      const res = await getSchoolList()
    },
    async getCollegeList() {
      const res = await getCollegeList()
      console.log(res)
    },
  },

  mounted() {
    this.initSubject()
    if (this.$route.query.type == 1) {
      // 个人中心修改时，银行帐号等信息不为空
      this.setBankRequst(0)
    }
    const timezone = jstz.determine()
    // console.log(timezone.name())
    this.getTimeZoneList()
    this.getCountryList()
    // this.getSchoolList();
    // this.getCollegeList();
    if (!!this.$refs.timezone) {
      document.addEventListener('click', (e) => {
        if (!this.$refs.timezone.contains(e.target)) {
          this.showZone = false
        }
      })
    }
  },
  computed: {
    myHeaders() {
      // 上传头部带token
      return { Authorization: 'TOKEN ' + sessionStorage.getItem('1to1token') }
    },
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  destroyed() {
    if (!!this.$refs.timezone) {
      document.removeEventListener('click')
    }
  },
}
</script>
<style lang="scss" scoped>
.fill-box {
  padding: 60px 40px 42px;
}
.row {
  padding: 0 70px 0 360px;
  margin-bottom: 20px;
  position: relative;
}
.lab {
  position: absolute;
  top: 0;
  left: 0;
  width: 340px;
  text-align: right;
  line-height: 42px;
}
.require:before {
  content: '*';
  color: #f00;
}
.fill-input {
  width: 100%;
  height: 42px;
  border-radius: 42px;
  padding: 10px 22px 10px 22px;
  line-height: 20px;
  border: 1px solid #ededed;
  background: #ededed;
  &:focus {
    border-color: #002147;
  }
}
.line {
  margin: 50px 0 30px;
  border: 1px dashed #707070;
}
.tip {
  line-height: 16px;
  font-size: 12px;
  color: #999;
  margin: 0 0 -6px 20px;
}
.subList {
  margin: -20px -60px 0 0;
  overflow: hidden;
  li {
    float: left;
    margin-top: 20px;
    padding-right: 50px;
  }
  .fill-input {
    width: 274px;
  }
  .num {
    display: inline-block;
    width: 42px;
    text-align: right;
  }
}
.img-list {
  overflow: hidden;
  display: inline-block;
  .btn-delete {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 46px;
    background: rgba($color: #000, $alpha: 0.74) url(../assets/delete2.png)
      no-repeat center center;
    display: none;
  }
  li {
    background: url(../assets/add.png);
  }
  .avatar {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
  video {
    width: 100%;
    height: 100%;
    vertical-align: top;
    background: #fff;
  }
  .tip {
    display: block;
    line-height: 192px;
    text-align: center;
    background: #fff;
    font-size: 24px;
  }
}
.tip2 {
  color: #999;
  margin: 5px 0 25px;
}
.fill-area {
  width: 100%;
  height: 220px;
  resize: none;
  border: 1px solid #ddd;
  margin: 30px 0;
  padding: 20px;
  &:focus {
    border-color: #002147;
  }
}
.bottom {
  margin: 100px 0;
  text-align: center;
}
.btn-submit {
  display: inline-block;
  border-radius: 60px;
  height: 60px;
  min-width: 320px;
  background: #002147;
  color: #fff;
  line-height: 60px;
  font-size: 18px;
}
.title {
  font-size: 24px;
  padding: 40px 0 20px 14px;
}
.exper {
  td {
    padding: 10px;
  }
}
.university .ui-select {
  margin-left: 14px;
}
.unit {
  margin-left: 20px;
}
.error {
  padding-left: 22px;
  font-size: 12px;
  color: red;
  line-height: 1;
  margin: 2px 0 -14px;
  display: none;
}
.isError {
  .error {
    display: block;
  }
  .fill-input,
  .fill-area {
    border-color: red;
  }
}
.input-select {
  width: 440px;
  position: relative;
}
.select-item {
  position: absolute;
  top: 1px;
  right: 1px;
  height: 40px;
  overflow: hidden;
  border-radius: 40px;
  .el-input__inner {
    border: 0 !important;
  }
}
.timezone {
  position: relative;
  .zonevalue {
    display: inline-block;
    padding: 0 42px;
    height: 42px;
    line-height: 42px;
    background: url(../assets/time.png) no-repeat left center;
    vertical-align: top;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      right: 9px;
      top: 17px;
      border-top: 8px solid #666;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
    }
  }
  .zone-list {
    position: absolute;
    top: 42px;
    left: 22px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.16);
    padding: 5px 0;
    z-index: 99;
    max-height: 150px;
    overflow: auto;
    li {
      line-height: 30px;
      padding: 0 40px 0 20px;
      transition: color 0.3s;
      white-space: nowrap;
      cursor: pointer;
      &.on,
      &:hover {
        color: #002147;
      }
    }
  }
}
.subMore {
  border: 0;
  border-bottom: 1px solid #ddd;
  width: 200px;
  &:focus {
    border-color: #002147;
  }
}
</style>